import { postWireDisbursementAsync } from 'API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: createWireDisbursementSlice, asyncAction: createWireDisbursementAsyncAction } = createAsyncSlice(
  'creteWireDisbursementsSlice',
  postWireDisbursementAsync
);
